import { sectionRenderer, normalizeSectionId } from '@theme/section-renderer';

class ScentPicker extends HTMLElement {
  constructor() {
    super();
    // this.abortController = null;
  }
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    // this.abortController?.abort();
  }

  /**
   * @param {MouseEvent} event
   */
  handleClick(event) {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('.product-scent');
    if (!button || !this.contains(button)) return;

    const { productId, productUrl } = /** @type {HTMLElement} */ (button).dataset;
    if (!productUrl || productId === this.dataset.currentProductId) return;

    // this.abortController?.abort();
    // this.abortController = new AbortController();

    const url = new URL(productUrl, window.location.origin);
    history.pushState({}, '', url);

    const scentNotesSection = document.querySelector('.scent-notes-section')?.closest('.shopify-section');
    const sectionIds = [this.dataset.sectionId, scentNotesSection && normalizeSectionId(scentNotesSection.id)];

    for (const sectionId of sectionIds) {
      if (sectionId) sectionRenderer.renderSection(sectionId, { url: new URL(url) });
    }
  };
}

if (!customElements.get('scent-picker')) {
  customElements.define('scent-picker', ScentPicker);
}
